export const API = {
  RAK_ID: {
    AUTH: '/auth2/auth',
    REFRESH_TOKEN: '/auth2/token',
    USER_PROFILE: '/users2/me',
    LOGOUT: '/auth2/logout',
  },
};
